import { Button as CommonButton } from "common/pixi/button";
import { cancel, delayAnimation } from "common/promises";
import { Sheets } from "common/sheets";
export class Button extends CommonButton {
    constructor(pixiContext, sheets) {
        const textures = Sheets.animationTextures(sheets, "button");
        const hitArea = {
            x: 243,
            y: 981,
            w: 234,
            h: 123,
        };
        super({
            pixiContext,
            textures,
            hitArea,
            hideButtonWhenclick: false,
        });
        this.animation = null;
    }
    animate() {
        this.animation = cancel.root(async (canceler) => {
            while (true) {
                canceler.check();
                await delayAnimation(100);
                canceler.check();
                this.sprite.texture = this.config.textures[0];
                await delayAnimation(100);
                canceler.check();
                this.sprite.texture = this.config.textures[1];
            }
        });
    }
    async dispose() {
        var _a;
        await super.dispose();
        (_a = this.animation) === null || _a === void 0 ? void 0 : _a.canceler.cancel();
    }
}
//# sourceMappingURL=buttons.js.map